import { render, staticRenderFns } from "./SuccessPrompt.vue?vue&type=template&id=400fb3be"
import script from "./SuccessPrompt.vue?vue&type=script&lang=js"
export * from "./SuccessPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports